import { Accordion, Link } from '@iwoca/orion';

import styles from './OpenBankingFAQ.module.css';

export const OpenBankingFAQ = ({
  isMobile = false,
}: {
  isMobile?: boolean;
}) => {
  return (
    <>
      {!isMobile && <h2 className={styles.heading}>Thanks for helping</h2>}
      <h3 className={styles.faqTitle}>FAQs</h3>
      <div className={styles.accordionContainer}>
        <Accordion
          data-testid="iwoca-faq"
          className={styles.accordion}
          titleClassName={styles.accordionTitle}
          title="Who are iwoca?"
          frame={false}
          small
        >
          <>
            iwoca is a UK company that provides loans to small businesses. Visit{' '}
            <Link
              className={styles.link}
              href="/"
              target="_blank"
              rel="noreferrer noopener"
            >
              iwoca.co.uk
            </Link>{' '}
            to learn more.
          </>
        </Accordion>
        <Accordion
          className={styles.accordion}
          titleClassName={styles.accordionTitle}
          title="What information does iwoca need?"
          frame={false}
          small
        >
          iwoca needs account information like transaction data and balance to
          assess a company’s creditworthiness before offering a loan. Our
          customers can provide this information by uploading a number of bank
          statements, or by linking their account via Open Banking.
        </Accordion>
        <Accordion
          className={styles.accordion}
          titleClassName={styles.accordionTitle}
          title="What is Open Banking?"
          frame={false}
          small
        >
          <>
            Open banking is a secure way to share limited access to your bank
            account with trusted companies. It was introduced by an EU directive
            to make banking more transparent, secure, and customer-friendly. In
            the UK, it’s regulated by the Financial Conduct Authority (FCA).
            Visit{' '}
            <Link
              className={styles.link}
              href="https://www.openbanking.org.uk/what-is-open-banking/"
              target="_blank"
              rel="noreferrer noopener"
            >
              openbanking.org.uk
            </Link>{' '}
            to learn more.
          </>
        </Accordion>
        <Accordion
          className={styles.accordion}
          titleClassName={styles.accordionTitle}
          title="How does iwoca use Open Banking?"
          frame={false}
          small
        >
          <>
            iwoca’s partner,{' '}
            <Link
              className={styles.link}
              href="https://truelayer.com/"
              target="_blank"
              rel="noreferrer noopener"
            >
              TrueLayer
            </Link>
            , will retrieve transaction information directly from the company’s
            bank and share that information with us. When iwoca’s customer
            chooses to link their bank account via Open Banking, they’ll first
            be asked to consent to iwoca accessing their transaction
            information, and then their bank will ask them to log in to
            authenticate the request. In this case, they have asked you to do
            that authentication.
          </>
        </Accordion>
        <Accordion
          className={styles.accordion}
          titleClassName={styles.accordionTitle}
          title="Is this information safe and secure?"
          frame={false}
          small
        >
          <ul className={styles.accordionList}>
            <li>
              You don’t share any credentials with iwoca or with our partner,
              TrueLayer; you authenticate directly with the bank.
            </li>
            <li>
              TrueLayer is authorised and regulated by the Financial Conduct
              Authority (FCA), which requires them to use secure, encrypted
              communication channels.
            </li>
            <li>iwoca’s customers can withdraw consent at any time.</li>
            <li>All data are handled according to UK data protection laws.</li>
          </ul>
        </Accordion>
      </div>
    </>
  );
};
